import { jsx, jsxs } from "react/jsx-runtime";
import { useGraphiQL } from "../provider.js";
/* empty css          */
const CONNECTION_LABEL = {
  idle: "Idle",
  connecting: "Connecting",
  connected: "Connected",
  error: "Connection error"
};
const StatusBarView = ({
  connectionStatus,
  typeCount
}) => /* @__PURE__ */ jsxs("footer", { className: "graphiql-status-bar", role: "contentinfo", children: [
  /* @__PURE__ */ jsxs("span", { className: `graphiql-status-bar-conn graphiql-status-bar-conn-${connectionStatus}`, title: CONNECTION_LABEL[connectionStatus], children: [
    /* @__PURE__ */ jsx("span", { className: "graphiql-status-bar-conn-dot", "aria-hidden": "true" }),
    CONNECTION_LABEL[connectionStatus]
  ] }),
  connectionStatus !== "idle" && /* @__PURE__ */ jsxs("span", { className: "graphiql-status-bar-types", children: [
    typeCount,
    " types"
  ] })
] });
const StatusBar = () => {
  const schema = useGraphiQL((state) => state.schema);
  const fetchError = useGraphiQL((state_0) => state_0.fetchError);
  const isIntrospecting = useGraphiQL((state_1) => state_1.isIntrospecting);
  const isFetching = useGraphiQL((state_2) => state_2.isFetching);
  const lastResponse = useGraphiQL((state_3) => state_3.lastResponse);
  const typeCount = schema ? Object.keys(schema.getTypeMap()).length : 0;
  const connectionStatus = (() => {
    if (fetchError || (lastResponse == null ? void 0 : lastResponse.ok) === false) {
      return "error";
    }
    if (isIntrospecting || isFetching) {
      return "connecting";
    }
    if (schema != null) {
      return "connected";
    }
    return "idle";
  })();
  return /* @__PURE__ */ jsx(StatusBarView, { connectionStatus, typeCount });
};
export {
  StatusBar,
  StatusBarView
};
//# sourceMappingURL=index.js.map
